/**
 * @fileoverview Barrel exports for the inspiration-attribute-deriver-v1 agent.
 *
 * This module provides a co-located agent following the agent-per-folder pattern:
 * - definition.ts: Agent metadata and configuration
 * - schema.ts: Input/output Zod schemas
 * - prompt.ts: Handlebars prompt template
 * - flow.ts: Genkit flow implementation
 */

export { definition } from './definition';

export {
  InputSchema,
  OutputSchema,
  HookInputSchema,
  DerivedAttributesSchema,
  type Input,
  type Output,
  type HookInput,
  type DerivedAttributes,
} from './schema';

export { flow, inspirationAttributeDeriverV1AgentFlow } from './flow';

export { prompt } from './prompt';
